
import { useScrollAnimation, getAnimationClass } from '../../../hooks/useScrollAnimation';

function AnimatedSection({ children, animation = 'slide-up' as 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in', className = '' }: { children: React.ReactNode; animation?: 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in'; className?: string }) {
  const { ref, isVisible } = useScrollAnimation();
  return (
    <div ref={ref} className={`${getAnimationClass(isVisible, animation)} ${className}`}>
      {children}
    </div>
  );
}

export default function FinalCTA() {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20ophthalmology%20clinic%20interior%20with%20advanced%20eye%20examination%20equipment%20and%20warm%20ambient%20lighting%20professional%20medical%20environment%20with%20emerald%20green%20accent%20colors%20elegant%20sophisticated%20atmosphere&width=1920&height=600&seq=cta-bg-final-1&orientation=landscape"
          alt="Clínica oftalmológica moderna"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/85 via-gray-900/75 to-gray-900/85"></div>
      </div>

      <AnimatedSection animation="scale-in" className="relative z-10">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl lg:text-5xl font-bold text-white mb-5 leading-tight">
            ¿Listo para transformar tu
            <span className="font-display italic text-emerald-400"> consulta</span>?
          </h2>
          <p className="text-base text-white/80 mb-10 max-w-2xl mx-auto">
            Únete a los profesionales de la salud visual que ya optimizaron su flujo de trabajo con Anamnesy Soft. Implementación en 48 horas con capacitación incluida.
          </p>
          <div className="flex items-center justify-center space-x-4">
            <a href="https://anamnesysoft.com/" target="_blank" rel="noopener noreferrer" className="px-8 py-3.5 bg-emerald-500 text-white text-sm font-semibold rounded-lg hover:bg-emerald-600 transition-all hover:shadow-lg hover:shadow-emerald-500/25 whitespace-nowrap cursor-pointer">
              Registrarse / Ingresar
            </a>
            <a href="#contacto" className="px-8 py-3.5 bg-white/10 text-white text-sm font-semibold rounded-lg border border-white/20 hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer">
              Contactar Ventas
            </a>
          </div>
        </div>
      </AnimatedSection>
    </section>
  );
}
